<template>
  <div class="container-fluid p-0">
    <PageTitle :title="$t('label.especie')" :isAdd="true"/>
    <!-- filtro -->
    <div class="row">
      <div class="col-12 d-flex">
        <div class="card flex-fill">
          <div class="card-body p-0 box-dashboard">
            <div class="align-self-center">
              <form class="row g-3 p-3 pb-0 filtro_especie" @submit.prevent="search">
                <div class="col-12 col-lg-7">
                  <v-select :appendToBody="true" :filterable="false" @search="getSpecies" :options="speciesList" v-model="formSearch.species_id" label="scientific_name" index="species_id"
                    :reduce="r => r.species_id" :clearable="false" class="bg-laranja-select vue-select">
                    <template v-slot:selected-option="option">
                      {{ `${option.scientific_name}` }}
                    </template>
                    <template v-slot:option="option">
                      {{ `${option.scientific_name}` }}
                    </template>
                    <template v-slot:no-options="{ search, searching }">
                      <template v-if="searching">
                        {{`${ $t('message.noResultsFor') } `}}<em>{{ search }}</em>.
                      </template>
                    </template>
                  </v-select>
                </div>
                <div class="col-12 col-lg-4 ml-auto text-right pt-1">
                  <button type="button" @click="clear" class="btn btn-outline-secondary mt-1 mb-2 mr-1">
                    {{ $t('label.limpar') }}
                  </button>
                  <button type="submit" class="btn bt-filtrar mt-1 mb-2">
                    Buscar
                  </button>
                </div>
              </form>

              <div class="row mt-1 mt-xl-2 p-3 bg_table_header">
                <div class="col-auto d-none d-sm-block">
                  <p class="mb-0 mt-2">
                    {{ $t('label.numRegistrosEncontrados') }}
                    <span class="laranja">{{$store.state.countList}}</span>
                  </p>
                </div>

                <div class="col-auto ml-auto text-right select_registro">
                  <select class="selectpicker" ref="select" v-model="$store.state.perPage" @change="search">
                    <option selected value="10">{{ $t('label.exibir10Reg') }}</option>
                    <option value="25">{{ $t('label.exibir25Reg') }}</option>
                    <option value="50">{{ $t('label.exibir50Reg') }}</option>
                    <option value="100">{{ $t('label.exibir100Reg') }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /filtro -->

    <!-- tabela -->
    <div class="row">
      <div class="col-12 d-flex">
        <div class="card flex-fill">
          <div class="card-body box-dashboard p-0">
            <div class="align-self-center">
              <div class="table-responsive full_table mt-0">
                <table class="table caption-top">
                  <thead class="bg_table_header">
                    <tr>
                      <th class="col-md-7 py-3 pl-7">{{ $t('label.especie') }}</th>
                      <th class="col-md-4 py-3 pl-4 pr-4 text-right">{{ $t('label.acoes') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="$store.state.countList === 0"><td colspan="4" class="text-center">{{ $t('message.noRecords') }}</td></tr>
                    <tr v-else v-for="item in items" :key="item.species_id">
                      <td class="py-3 pl-3">{{item.scientific_name}}</td>
                      <td class="py-3">
                        <ul class="acoes text-right pr-1">
                          <li>
                            <a @click="action($actionEdit, item)"><span class="editar"></span></a>
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <TablePagination v-on:searchTable="search()"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /tabela -->
  </div>
</template>

<script>
import axios from 'axios'
import TablePagination from '@/components/shared/TablePagination'
import PageTitle from '@/components/shared/PageTitle'
export default {
  name: 'EspecieEmail',
  components: { TablePagination, PageTitle },
  data: function () {
    return {
      formSearch: { species_id: '' },
      speciesList: [{ species_id: '', scientific_name: this.$t('label.nomeCientifico') }],
      items: [],
      listPagination: [],
      rangePagination: [],
      countPages: 0
    }
  },
  methods: {
    clear: function () {
      this.formSearch = { species_id: '' }
    },
    action: function (action, item) {
      if (action === this.$actionDelete) {
        if (confirm(this.$t('message.confirmDel'))) {
          this.delete(item)
        }
      } else {
        this.$router.push({ name: 'EspecieEmailForm', params: { id: item.species_id } })
      }
    },
    search: function () {
      this.$store.dispatch('showPreload')

      const params = this.formSearch
      params.Page = this.$store.state.currentPage
      params.PageSize = this.$store.state.perPage
      params.species_id_array = this.formSearch.species_id
      axios.get('/Specie/getallgrid', { params })
        .then(response => {
          this.$store.state.currentPage = response.data.page
          this.$store.state.countList = response.data.count
          this.items = response.data.items
        })
    },
    getSpecies: function (search, loading) {
      const params = {
        Page: 1,
        PageSize: 9999
      }
      if (search && search.length > 2) {
        params.scientific_name = search
        params.species_id_array = this.formSearch.species_id
        loading(true)
        axios.get('/Specie/getallcombo', { params })
          .then(response => {
            this.speciesList = response.data.items
            this.speciesList.unshift({ species_id: '', scientific_name: this.$t('label.nomeCientifico') })
            loading(false)
          })
      } else if (!search) {
        params.species_id_array = this.formSearch.species_id
        axios.get('/Specie/getallcombo', { params })
          .then(response => {
            this.speciesList = response.data.items
            this.speciesList.unshift({ species_id: '', scientific_name: this.$t('label.nomeCientifico') })
          })
      }
    }
  },
  created: function () {
    this.getSpecies()
    this.search()
  }
}
</script>
